import MarketplaceApi from 'api/MarketplaceApi';
import { IItemObj } from 'api/types/marketplace';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { getCatchError } from 'utils/errorHandler';
import Header from '../../layouts/header';
import HomeBanner from '../../layouts/Banner';
import CardLists from './partials/CardLists';

import Loader from '../../assets/images/loader/spin.gif';

function HomePage() {
  const [itemsList, setItemsList] = useState<Array<IItemObj>>([]);
  const [itemFetchLoader, setItemFetchLoader] = useState<boolean>(true);
  const [pageSpinnerLoader, setPageSpinnerLoader] = useState<boolean>(true);
  const [totalRows, setTotalRows] = useState<number>(0);

  const fetchItemsList = useCallback(async () => {
    try {
      setItemFetchLoader(true);

      const response = await MarketplaceApi.getItemsList();

      setItemsList(response.data.data.items);
      setTotalRows(response.data.data.totalRecords);
    } catch (err) {
      toast.error(getCatchError(err)[0]);
    } finally {
      setItemFetchLoader(false);
    }
  }, []);

  useEffect(() => {
    fetchItemsList();
    setTimeout(() => {
      setPageSpinnerLoader(false);
    }, 1000);
  }, [fetchItemsList]);

  return (
    <div className="app-wrapper">
      <Header />
      <main className="main-wrapper">
        <HomeBanner />

        {(itemFetchLoader || pageSpinnerLoader) && (
          <div className="section-loader">
            <div className="loader">
              <img src={Loader} className="img-fluid" alt="Loader" />
            </div>
          </div>
        )}

        {!itemFetchLoader && !pageSpinnerLoader && (
          <Fragment>
            <CardLists itemsList={itemsList} totalRows={totalRows} />
          </Fragment>
        )}
        <div className="gradient-fade"></div>
      </main>
    </div>
  );
}

export default HomePage;
